import { storyblokEditable } from '@storyblok/react'
import React from 'react'

import { ContentThumb } from 'components/blocks/sections/directories/thumbs/ContentThumb'
import { SelectedPatientStoriesStoryblok } from 'lib/storyblok/types'

import { NewCarousel } from './NewCarousel'

type Props = {
  block: SelectedPatientStoriesStoryblok
}

export const SelectedPatientStories = ({
  block,
  ...rest
}: Props): JSX.Element => {
  const { title, items, variant } = block

  return (
    <section
      {...storyblokEditable(block)}
      className="max-w-screen-desktop mx-auto flex flex-col px-5 lg:px-20 py-10 lg:py-15 gap-8 lg:gap-15"
    >
      <h2 className="font-regular text-title-medium md:text-title">{title}</h2>

      {variant === 'grid' && (
        <div
          {...rest}
          className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3"
        >
          {items?.map(
            (item) =>
              typeof item !== 'string' && (
                <ContentThumb key={item.uuid} item={item} />
              )
          )}
        </div>
      )}

      {variant === 'slider' && (
        <NewCarousel className="max-h-fit">
          <div className="flex gap-4 lg:gap-8 w-max">
            {items?.map(
              (item) =>
                typeof item !== 'string' && (
                  <div
                    className="w-[280px] sm:w-[350px] lg:w-[400px]"
                    key={item.uuid}
                  >
                    <ContentThumb key={item.uuid} item={item} />
                  </div>
                )
            )}
          </div>
        </NewCarousel>
      )}
    </section>
  )
}
